import { ref } from 'vue'
import { defineStore } from 'pinia'
import { useConfigStore } from '@/stores/config'
import { useRequestsStore } from '@/stores/requests'
import { useTokenStore } from '@/stores/token'

export const useCarGroupsStore = defineStore('car-groups', () => {
  
    const configStore = useConfigStore()
    const requestsStore = useRequestsStore()
    const tokenStore = useTokenStore()

    const carGroups = ref({})
    const carGroupsProcess = ref(false)
    const carGroupsMsg = ref({})

    const carGroupsCreateList = ref({})
    const carGroupsCreateListProcess = ref(false)
    const carGroupsCreateListMsg = ref({})

    const carGroupsCreateProcess = ref(false)
    const carGroupsCreateMsg = ref({})

    const carGroupsUpdateProcess = ref(false)
    const carGroupsUpdateMsg = ref({})

    const carGroupsDeleteProcess = ref(false)
    const carGroupsDeleteMsg = ref({})

    async function createCarGroup(payload) {

        carGroupsCreateProcess.value = true
        const token = tokenStore.access

        if(token) {
            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/cgroups/links/cars`, 
                method: 'POST', 
                token,
                data: payload
            })
            if(!request.error) {
                carGroupsCreateMsg.value = { success: true, text: 'CARS_GROUPS_CREATE_SUCCESS' }
            } else {
                carGroupsCreateMsg.value = { success: false, text: request.error }
            }
        } else {
            carGroupsCreateMsg.value = { success: false, text: 'EUnauthRequest' }
        }

        carGroupsCreateProcess.value = false
    }

    async function readCarGroupsCreateList(payload) {

        carGroupsCreateListProcess.value = true
        const token = tokenStore.access

        if(token) {
            let params = ''
            if(payload) {
                for( let param in payload) {
                    params.length ?
                        params += '&' + param + '=' + payload[param] :
                        params = '?' + param + '=' + payload[param]
                }
            }
            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/cgroups${params}`, 
                method: 'GET', 
                token
            })
            if(!request.error) {
                carGroupsCreateList.value = request
                carGroupsCreateListMsg.value = { success: true }
            } else {
                carGroupsCreateList.value = {}
                carGroupsCreateListMsg.value = { success: false, text: request.error}
            }
        } else {
            carGroupsCreateListMsg.value = { success: false, text: 'EUnauthRequest' }
        }

        carGroupsCreateListProcess.value = false
        return carGroupsCreateList.value
    }

    async function readCarGroups(payload) {

        carGroupsProcess.value = true
        const token = tokenStore.access

        if(token) {

            let params = ''

            if(payload) {
                for( let param in payload) {
                    params.length ?
                        params += '&' + param + '=' + payload[param] :
                        params = '?' + param + '=' + payload[param]
                }
            }

            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/cgroups/links/cars${params}`, 
                method: 'GET', 
                token
            })

            if(!request.error) {
                if(request.cgroups.length) {
                    carGroups.value = request
                    carGroupsMsg.value = { success: true, text: '' }
                } else if(!request.cgroups.length) {
                    carGroups.value = {}
                    carGroupsMsg.value = { success: false, text: 'CAR_GROUPS_EMPTY' }
                }
            } else {
                carGroups.value = {}
                carGroupsMsg.value = { success: false, text: request.error }
            }

        } else {
            carGroupsMsg.value = { success: false, text: 'EUnauthRequest' }
        }

        carGroupsProcess.value = false
        return carGroups.value
    }

    async function updateCarGroups(payload) {

        carGroupsUpdateProcess.value = true
        const token = tokenStore.access

        if(token) {

            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/cgroups/links/cars`, 
                method: 'PUT', 
                token,
                data: payload
            })

            if(!request.error) {
                carGroupsUpdateMsg.value = { success: true, text: 'CARS_GROUP_UPDATE_SUCCESS' }
            } else {
                carGroupsUpdateMsg.value = { success: false, text: request.error }
            }

        } else {
            carGroupsUpdateMsg.value = { success: false, text: 'EUnauthRequest' }
        }

        carGroupsUpdateProcess.value = false
    }

    async function deleteCarGroups(payload) {

        carGroupsDeleteProcess.value = true
        const token = tokenStore.access

        if(token) {

            let params = ''

            if(payload) {
                for( let param in payload) {
                    params.length ?
                        params += '&' + param + '=' + payload[param] :
                        params = '?' + param + '=' + payload[param]
                }
            }

            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/cgroups/links/cars${params}`, 
                method: 'DELETE', 
                token
            })

            if(!request.error) {
                carGroupsDeleteMsg.value = { success: true, text: 'CARS_GROUPS_DELETE_SUCCESS' }
            } else {
                carGroupsDeleteMsg.value = { success: false, text: request.error }
            }

        } else {
            carGroupsDeleteMsg.value = { success: false, text: 'EUnauthRequest' }
        }

        carGroupsDeleteProcess.value = false
    }

    const setCarGroups             = data => carGroups.value            = data
    const setCarGroupsCreateMsg    = data => carGroupsCreateMsg.value   = data
    const setCarGroupsUpdateMsg    = data => carGroupsUpdateMsg.value   = data
    const setCarGroupsDeleteMsg    = data => carGroupsDeleteMsg.value   = data

    return {

        carGroups, 
        carGroupsProcess, 
        carGroupsMsg, 
        carGroupsCreateList, 
        carGroupsCreateListProcess, 
        carGroupsCreateListMsg, 
        carGroupsCreateProcess, 
        carGroupsCreateMsg, 
        carGroupsUpdateProcess, 
        carGroupsUpdateMsg, 
        carGroupsDeleteProcess, 
        carGroupsDeleteMsg, 
        createCarGroup, 
        readCarGroupsCreateList, 
        readCarGroups, 
        updateCarGroups, 
        deleteCarGroups, 
        setCarGroups, 
        setCarGroupsCreateMsg,
        setCarGroupsUpdateMsg,
        setCarGroupsDeleteMsg
    }
})